import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../pages/loginPage.vue'
import Intro from '../pages/intro.vue'
import Class from '../pages/class.vue'
import RestPw from '../pages/restPwPage.vue'
import UnLock from '../pages/unLockPage.vue'
import ResonAdd from '../pages/reasonAddPage.vue'
import ResonList from '../pages/reasonListPage.vue'
import ReviewList from '../pages/reviewListPage.vue'
import Review from '../pages/reviewPage.vue'
import NoticeList from "../pages/noticeListPage.vue"
import NoticeAdd from "../pages/noticeAddPage.vue"
import NoticeView from "../pages/noticeViewPage.vue"
import EmailAdd from "../pages/emailAddPage.vue"
import todayEng from "../pages/todayEngPage.vue"
import untactTest from "../pages/untactTestPage.vue"
import untactAdd from "../pages/untactAddPage.vue"
import untactView from "../pages/untactViewPage.vue"
import MyInfo from "../pages/myInfoPage.vue"
import ChangePw from "../pages/changePwPage.vue"
import NoticeModfiy from "../pages/noticeModfiyPage.vue"
import UntactModfiy from "../pages/untactModfiyPage.vue"
import Pop_evview from "../pages/pop_evwriting_view.vue";
import authLogin from "../pages/authloginPage.vue"
import Writing_send from '../pages/writing_send.vue'
import WritingMod from '../pages/writingMod.vue'
import HowIntro from '../pages/how/intro.vue';
import HowPrivacy from '../pages/how/privacy.vue';
import HowTerms from "../pages/how/terms.vue";
import error from '../pages/error.vue';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/intro',
    name: 'Intro',
    component: Intro
  },
  {
    path: '/class',
    name: 'Class',
    component: Class,
    props:true
  },
  {
    path: '/restpw',
    name: 'RestPw',
    component: RestPw,
    props:true
  },
  {
    path: '/unlock',
    name: 'UnLock',
    component: UnLock,
    props:true
  },
  {
    path: '/reasonadd',
    name: 'ResonAdd',
    component: ResonAdd,
    props:true
  },
  {
    path: '/reasonlist',
    name: 'ResonList',
    component: ResonList,
    props:true
  },
  {
    path: '/reviewlist',
    name: 'ReviewList',
    component: ReviewList,
    props:true
  },
  {
    path: '/review',
    name: 'Review',
    component: Review,
    props:true
  },
  {
    path: '/noticelist',
    name: 'NoticeList',
    component: NoticeList,
    props:true
  },
  {
    path: '/noticeadd',
    name: 'NoticeAdd',
    component: NoticeAdd,
    props:true
  },
  {
    path: '/noticemodfiy',
    name: 'NoticeModfiy',
    component: NoticeModfiy,
    props:true
  },
  {
    path: '/noticeview',
    name: 'NoticeView',
    component: NoticeView,
    props:true
  },
  {
    path: '/emailadd',
    name: 'EmailAdd',
    component: EmailAdd
  },
  {
    path: '/todayeng',
    name: 'todayEng',
    component: todayEng
  },
  {
    path: '/untacttest',
    name: 'untactTest',
    component: untactTest
  },
  {
    path: '/untactadd',
    name: 'untactAdd',
    component: untactAdd
  },
  {
    path: '/untactview',
    name: 'untactView',
    component: untactView,
    props:true
  },
  {
    path: '/myinfo',
    name: 'MyInfo',
    component: MyInfo
  },
  {
    path: '/changePw',
    name: 'ChangePw',
    component: ChangePw,
    props:true
  }
  ,
  {
    path: '/untactmodfiy',
    name: 'UntactModfiy',
    component: UntactModfiy,
    props:true
  },
  {
    path:"/pop_evview",
    name: 'Pop_evview',
    component: Pop_evview,
    props:true
  },
  {
    path:"/authLogin",
    name:"authLogin",
    component:authLogin,
    props:true
  },
  {
    path:"/writing_send",
    name:"Writing_send",
    component:Writing_send,
    props:true
  },
  {
    path:"/writingmod",
    name:"WritingMod",
    component:WritingMod,
    props:true
  },
  {
    path:"/how_intro",
    name:"HowIntro",
    component:HowIntro,
    props:true
  },
  {
    path:'/how_privacy',
    name:"HowPrivacy",
    component:HowPrivacy,
    props:true
  },
  {
    path:"/how_terms",
    name:"HowTerms",
    component:HowTerms,
    props:true
  },
  {
    path:'*',
    redirect: '/error'
  },
  {
    path:'/error',
    component: error
  }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

